import { useEffect, useState } from 'react';
import { StyleSheet, View, Pressable } from 'react-native';
import { MultiSelect } from 'react-native-element-dropdown';
import { colorList } from 'utils/colors';
import { ThemedValues, ThemedFonts, ThemedShared } from 'styles/themed'
import Text from 'theme/Text';
import Icon from 'components/atoms/Icon';
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import i18n from 'utils/i18n';

const SelectMulti = ({ data = [], onSelect, selected, style, placeholder = i18n.t( 'form.select.placeholder' ), disabled = false, search = false, testID, accessibilityLabel }) => {

    const [ isFocus, setIsFocus ] = useState(false);
    const [ values, setValues ] = useState( selected ?? [] );

    useEffect( () => {
        setValues( selected ?? [] );
    }, [ selected ] );

    const onChange = ( item ) => {
        if( disabled ) {
            return;
        }

        // Update the state
        setValues( item )

        // Trigger the onSelect callback
        if (onSelect) {
            onSelect( item );
        }
    }

    const renderItem = item => {
        return (
            <View style={styles.item}>
                <Text style={styles.selectedTextStyle}>{item.label}</Text>
            </View>
        );
    };

    return (
        <MultiSelect
            style={[ 
                styles.dropdown, 
                isFocus && styles.multiSelectBorderColorLight,
                style,
            ]}
            placeholderStyle={ styles.placeholder }
            selectedTextStyle={ styles.selectedText }
            inputSearchStyle={ styles.inputSearch }
            itemTextStyle={ styles.itemText }
            iconStyle={ styles.iconStyle }
            activeColor={ colorList.PRIMARY.light }
            fontFamily={ ThemedFonts.regular.fontFamily }
            fontSize={ 14 }
            data={ data }
            search={ search || data?.length > 20 }
            disable={ disabled }
            testID={ testID }
            accessibilityLabel={ accessibilityLabel }
            value={ values }
            maxHeight={ 300} 
            labelField="label"
            valueField="value"
            placeholder={ typeof placeholder === 'string' ? placeholder : '' }
            searchPlaceholder={ i18n.t( 'form.select.search_placeholder' ) }
            onFocus={ setIsFocus.bind( this, true ) }
            onBlur={ setIsFocus.bind( this, false ) }
            onChange={ onChange }
            renderItem={ renderItem }
            renderSelectedItem={(item, unSelect) => {
                return (
                    <Pressable
                        disabled={ disabled }
                        onPress={() => {
                            if( !disabled && unSelect ) {
                                unSelect( item );
                            }
                        }}>

                        <View style={styles.selectedStyle}>
                            <Text
                                style={styles.textSelectedStyle}>

                                { item.label }
                            </Text>

                            <Icon
                                icon={ IconSystemConstants.TRASH }
                                size={ 14 }
                                style={ styles.textSelectedIcon }
                            />
                        </View>
                    </Pressable>
                );
            }}
        />
    )
}

const styles = StyleSheet.create({
	multiSelectBorderColorLight: {
		borderColor: colorList.PRIMARY.light,
	},
    container: {
        backgroundColor: colorList.WHITE.primary,
        padding: ThemedShared.paddingSmall.padding,
    },
    dropdown: {
        height: 40,
        borderColor: colorList.GREY.light,
        backgroundColor: colorList.WHITE.primary,
        borderWidth: 0.5,
        borderRadius: ThemedValues.borderRadius,
        paddingHorizontal: 8,
    },
    icon: {
        marginRight: 5,
    },

    label: {
        ...ThemedFonts.regular,
        fontSize: 14,

        position: 'absolute',
        backgroundColor: colorList.WHITE.primary,
        left: 22,
        top: 8,
        zIndex: 999,
        paddingHorizontal: 8,
    },
    itemText: {
        ...ThemedFonts.regular,
        fontSize: 14,
    },
    placeholder: {
        ...ThemedFonts.regular,
        fontSize: 14,
    },
    selectedText: {
        ...ThemedFonts.regular,
        fontSize: 14,
    },
    inputSearch: {
        ...ThemedFonts.regular,
        height: 40,
        fontSize: 14,
    },

    iconStyle: {
        width: 20,
        height: 20,
    },

    item: {
        padding: ThemedShared.paddingSmall.padding,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    selectedStyle: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: ThemedValues.borderRadius,
        backgroundColor: colorList.WHITE.light,
        marginTop: 8,
        marginRight: 12,
        padding: ThemedShared.paddingSmall.padding,
        backgroundColor: colorList.PRIMARY.light
    },
    textSelectedStyle: {
        marginRight: 5,
        color: colorList.TEXT.primary
    },
    textSelectedIcon: {
        color: colorList.TEXT.primary
    }
});

export default SelectMulti;
